<template>
  <div id="Header">
    <div class="headerContainer">
      <i @click="setShowMenu" class="fas fa-bars"></i>
      <img style="cursor: pointer" @click="goNTUA()" src="../assets/images/logo2.svg" alt="國立臺灣藝術大學LOGO" />

      <div class="headerContainer__link">
        <a href="https://www.ntua.edu.tw/file/114行事曆.pdf" target="_blank">114行事曆</a>
        <a href="https://www.ntua.edu.tw/file/115%E8%A1%8C%E4%BA%8B%E6%9B%86.pdf" target="_blank">115行事曆</a>
      </div>
    </div>
  </div>
</template>

<script>
import Identify from "../components/Identify";
export default {
  name: "Header",
  components: {
    Identify,
  },
  data() {
    return {
      loginDialog: false,
      account: "",
      password: "",
      showMenu: false,

      // 數字驗證
      code: "",
      identifyCodes: "1234567890",
      identifyCode: "",
    };
  },
  computed: {
    userName() {
      if (window.localStorage.getItem("user")) {
        return JSON.parse(window.localStorage.getItem("user")).RealName;
      } else {
        return "";
      }
    },
    hasRole() {
      if (window.localStorage.getItem("user")) {
        return (
          JSON.parse(window.localStorage.getItem("user")).RoleNames[0] || false
        );
      } else {
        return false;
      }
    },
  },
  methods: {
    loginHandler() {
      const vm = this;
      if (vm.account === "" || vm.password === "") {
        vm.$alertT.fire({
          icon: "error",
          title: `請確實填寫帳號密碼`,
        });
      } else {
        if (vm.identifyCode !== vm.code) {
          vm.$alertT.fire({
            icon: "error",
            title: `驗證碼輸入錯誤`,
          });
        } else {
          let params = {
            account: vm.account,
            password: vm.password,
          };
          vm.$api
            .GetToken(params)
            .then((res) => {
              if (res.data.success) {
                let token = res.data.token;
                vm.$store.commit("SAVE_TOKEN", token);
                let curTime = new Date();
                let expiredate = new Date(
                  curTime.setSeconds(curTime.getSeconds() + res.data.expires_in)
                );
                vm.$store.commit("SAVE_TOKEN_EXPIRE", expiredate);

                window.localStorage.refreshtime = expiredate;
                window.localStorage.expires_in = res.data.expires_in;
                vm.getInfoByToken(token);
              } else {
                // console.log(res);
                vm.$alertM.fire({
                  icon: "error",
                  title: res.data.message,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    getInfoByToken(token) {
      const vm = this;
      let params = {
        token,
      };
      vm.$api.GetInfoByToken(params).then((res) => {
        window.localStorage.user = JSON.stringify(res.data.response);
        vm.loginDialog = false;
        window.location.reload();
      });
    },

    logoutHandler() {
      const vm = this;
      vm.$confirm(`確認登出?`, "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("Token");
        window.localStorage.removeItem("TokenExpire");
        window.localStorage.removeItem("refreshtime");
        window.localStorage.removeItem("router");
        vm.$router.push("/Calendar");
        window.location.reload();
      });
    },
    setShowMenu() {
      this.showMenu = !this.showMenu;
      this.$emit("getShowMenu", this.showMenu);
    },
    // 生成隨機數
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 切換驗證碼
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 生成四位隨機驗證碼
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },

    goNTUA() {
      window.location.href = "https://www.ntua.edu.tw/";
    },
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
};
</script>

<style lang="scss" scope>
.headerContainer {
  &__link {
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: 12px;

    a {
      color: white;
      font-weight: bold;
      letter-spacing: 0.2rem;
      text-decoration: underline;
      transition: all 0.3s;

      &:hover {
        background: white;
        color: #484748;
      }
    }
  }
}
</style>
